module.exports = __webpack_public_path__ + "media/icons/location-eb9ac9de.png";